import Work1 from "../../assets/project-7.png";
import Work2 from "../../assets/project-1.png";
import Work3 from "../../assets/project-4.png";
import Work4 from "../../assets/project-2-1.png";
import Work5 from "../../assets/project-3.png";
import Work6 from "../../assets/project-6-1.png";
import Work7 from "../../assets/project-8.png";
import Work8 from "../../assets/project-9.png";

const Menu = [
  {
    id: 1,
    image: Work8,
    title: "DevLink - Enterprise Workforce Management Platform",
    category: ["Python"],
    url: "https://devlink.mooo.com",
    repositoryUrl: "https://github.com/Arun-21BEECE006/DevLink-Project",
    // repositoryUrl: "/"
  },
  {
    id: 2,
    image: Work7,
    title:
      "AI-Powered Resume Screening System",
    category: ["Python"],
    url: "https://ats-resume-analyzer-dp6l.onrender.com",
    repositoryUrl: "https://github.com/Arun-21BEECE006/ATS-resume-analyzer",
    // repositoryUrl: "/"
  },
  {
    id: 3,
    image: Work6,
    title: "Oral Cancer Detector using CNN & LSTM",
    category: ["Electronics"],
    url: "https://drive.google.com/drive/folders/1xtdiboWYoKK1yNv76EfQi8pcAshbYmHo?usp=sharing",
    repositoryUrl:
      "https://github.com/Arun-21BEECE006/Oral-Cancer-using-LSTM-Full-Code",
  },
  {
    id: 4,
    image: Work1,
    title:
      "Personal Portfolio Website",
    category: ["React"],
    url: "https://arun-portfolio-chi.vercel.app",
    repositoryUrl: "https://github.com/Arun-21BEECE006/My_Portfolio_Frontend",
    // repositoryUrl: "/"
  },
  {
    id: 5,
    image: Work2,
    title: "Cut-off Calculator Web Application",
    category: ["Frontend"],
    url: "https://cut-off-calculator.vercel.app",
    repositoryUrl: "https://github.com/Arun-21BEECE006/Cut-off-Calculator",
  },
  {
    id: 6,
    image: Work4,
    title:
      "Real-Time Object Detection System",
    category: ["Python"],
    url: "https://object-detector-using-python.onrender.com",
    repositoryUrl:
      "https://github.com/Arun-21BEECE006/Object-Detector-using-Python",
  },
  {
    id: 7,
    image: Work3,
    title: "Bookmark Manager Web Application",
    category: ["Frontend"],
    url: "https://bookmark-ak.vercel.app",
    repositoryUrl: "https://github.com/Arun-21BEECE006/Bookmark_Project-2",
  },
  {
    id: 8,
    image: Work5,
    title: "Alcohol Detection System with SMS Alerts",
    category: ["Electronics"],
    url: "https://drive.google.com/drive/u/0/folders/1vNISJbVtxlNbeNMkMiZUHUmBd9SC64L1",
    repositoryUrl:
      "https://github.com/Arun-21BEECE006/alcohol-detection-project",
  },
];

export default Menu;
